import { Link } from "react-router-dom";
import "./Footer.css";
import logo from "../../Images/ferramentum-logo.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  shopLinks,
  companyLinks,
  supportLinks,
  socials,
} from "../../Data/footerData";
import { toast } from "react-toastify";
import { useLanguage } from "../../Context/Language";
import {
  faEnvelope,
  faLocationDot,
  faArrowRight,
} from "@fortawesome/free-solid-svg-icons";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { t } = useLanguage();

  const renderLink = (link) => {
    if (link.href.startsWith("http") || link.href.startsWith("#")) {
      return (
        <a href={link.href} className="footer-link">
          {t(link.name)}
        </a>
      );
    }
    return (
      <Link to={link.href} className="footer-link">
        {t(link.name)}
      </Link>
    );
  };
  const handleSubscribe = () => {
    toast.success(t("Subscribed successfully!"));
  };

  return (
    <footer className="footer">
      <div className="footer-main">
        <div className="footer-container">
          <div className="footer-grid">
            <div className="footer-brand">
              <Link to="/" className="footer-logo">
                <img src={logo} alt="Ferramentum" />
              </Link>
              <p className="footer-tagline">
                {t("Affordable quality. Unbreakable spirit.")}
              </p>

              <div className="footer-contact-list">
                <a
                  href="mailto:info@ferramentum.se"
                  className="footer-contact-item"
                >
                  <FontAwesomeIcon icon={faEnvelope} />
                  <span>info@ferramentum.se</span>
                </a>
                <div className="footer-contact-item">
                  <FontAwesomeIcon icon={faLocationDot} />
                  <span>Sösdala 2098 28273 Sösdala, Sweden</span>
                </div>
              </div>

              <div className="footer-socials">
                {socials.map((s) => (
                  <a
                    key={s.label}
                    href={s.href}
                    className="social-link"
                    aria-label={s.label}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FontAwesomeIcon icon={s.icon} />
                  </a>
                ))}
              </div>
            </div>

            <div className="footer-links-group">
              <h4 className="footer-heading">{t("Shop")}</h4>
              <ul className="footer-links">
                {shopLinks.map((link) => (
                  <li key={link.name}>{renderLink(link)}</li>
                ))}
              </ul>
            </div>

            <div className="footer-links-group">
              <h4 className="footer-heading">{t("Company")}</h4>
              <ul className="footer-links">
                {companyLinks.map((link) => (
                  <li key={link.name}>{renderLink(link)}</li>
                ))}
              </ul>
            </div>

            <div className="footer-links-group">
              <h4 className="footer-heading">{t("Support")}</h4>
              <ul className="footer-links">
                {supportLinks.map((link) => (
                  <li key={link.name}>{renderLink(link)}</li>
                ))}
              </ul>
            </div>

            <div className="footer-newsletter">
              <h4 className="footer-heading">{t("Stay Updated")}</h4>
              <p className="newsletter-desc">
                {t("Subscribe for exclusive deals, new arrivals & tool tips.")}
              </p>
              <form
                className="newsletter-form"
                onSubmit={(e) => {
                  e.preventDefault();
                  handleSubscribe();
                }}
              >
                <div className="newsletter-input-wrap">
                  <input
                    type="email"
                    placeholder={t("Your email address")}
                    className="newsletter-input"
                    required
                  />
                  <button
                    type="submit"
                    className="newsletter-btn"
                    aria-label={t("Subscribe")}
                  >
                    <FontAwesomeIcon icon={faArrowRight} />
                  </button>
                </div>
              </form>
              <p className="newsletter-note">
                {t("No spam ever. Unsubscribe anytime.")}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-container">
          <div className="footer-bottom-inner">
            <p className="footer-copyright">
              &copy; {currentYear} Ferramentum. {t("All rights reserved.")}
            </p>
            <div className="footer-legal">
              <Link to="/privacy" className="legal-link">
                {t("Privacy Policy")}
              </Link>
              <Link to="/terms" className="legal-link">
                {t("Terms of Service")}
              </Link>
              <Link to="/cookies" className="legal-link">
                {t("Cookie Policy")}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
